import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi, { ISelectedAccountRequest } from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createSelectBankAccountThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(
    ApplicationProcessActionTypes.SelectBankAccount,
    async (payload: { applicationId: string; selectedAccount: ISelectedAccountRequest }) => {
      const response = await api.selectBankAccount(payload.applicationId, payload.selectedAccount);

      return response;
    },
  );
